import classNames from 'classnames';
import dayjs from 'dayjs';
import { Icon, TooltipNew } from 'ui';
import { CalendarCancelIcon, CalendarCheckIcon } from 'ui/icons';

interface TaskDatesProps {
  classes?: {
    container?: string;
  };
  current_start_date: string;
  overdue_date: string;
}

const TaskDates = ({ current_start_date, overdue_date, classes }: TaskDatesProps) => {
  return (
    <div className={classNames('w-[200px] hidden sm:block space-y-1', classes?.container)}>
      <TooltipNew text="Start date">
        <div className="flex items-center gap-2.5">
          <Icon Source={CalendarCheckIcon} color="gray" />
          <span className="text-sm text-[#6B6B6B]">
            {dayjs(current_start_date).format('DD-MM-YYYY, HH:mm')}
          </span>
        </div>
      </TooltipNew>
      <TooltipNew text="Due date">
        <div className="flex items-center  gap-2.5">
          <Icon Source={CalendarCancelIcon} color="gray" />
          <span className="text-sm text-[#6B6B6B]">
            {dayjs(overdue_date).format('DD-MM-YYYY, HH:mm')}
          </span>
        </div>
      </TooltipNew>
    </div>
  );
};

export default TaskDates;
